import { type FC } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';

import styles from './SaveSearchSuccessToastContent.module.css';
import dibsCss from 'dibs-css';

type SaveSearchSuccessToastContentProps = {
    isMobile?: boolean | null;
    isSeller?: boolean;
};

export const SaveSearchSuccessToastContent: FC<SaveSearchSuccessToastContentProps> = ({
    isMobile,
    isSeller,
}) => {
    const pageType = isSeller ? 'seller' : 'search';

    return (
        <div className={classNames(dibsCss.flex, dibsCss.flexCol, dibsCss.gap2px)}>
            <div
                className={classNames(
                    dibsCss.flex,
                    dibsCss.justifyBetween,
                    dibsCss.itemsCenter,
                    dibsCss.gapSmall
                )}
            >
                <span className={dibsCss.sassyFontBodySmallHeavy}>
                    <FormattedMessage
                        id="sb.SaveSearchSuccessToastContent.title"
                        defaultMessage="{pageType, select,
                            seller {Saved To Your Saved Sellers}
                            other {Saved To Your Saved Searches}
                        }"
                        values={{ pageType }}
                    />
                </span>
                <Link
                    href={isSeller ? '/favorites/sellers/' : '/favorites/searches/'}
                    target="_blank"
                    className={classNames(styles.link, dibsCss.sassyFontBodySmallHeavy)}
                >
                    {isMobile ? (
                        <FormattedMessage
                            id="sb.SaveSearchSuccessToastContent.linkMobile"
                            defaultMessage="{pageType, select, seller {View Sellers} other {View Searches}}"
                            values={{ pageType }}
                        />
                    ) : (
                        <FormattedMessage
                            id="sb.SaveSearchSuccessToastContent.linkDesktop"
                            defaultMessage="{pageType, select, seller {View Saved Sellers} other {View Saved Searches}}"
                            values={{ pageType }}
                        />
                    )}
                </Link>
            </div>
            {!isMobile && (
                <span className={dibsCss.sassyFontBodySmall}>
                    <FormattedMessage
                        id="sb.SaveSearchSuccessToastContent.disclaimer"
                        defaultMessage="Check your email for weekly updates."
                    />
                </span>
            )}
        </div>
    );
};

export const RemoveFromSavedSearchesToastContent: FC<{ isSeller?: boolean }> = ({ isSeller }) => (
    <div className={classNames(dibsCss.flex, dibsCss.itemsCenter, dibsCss.sassyFontBodySmallHeavy)}>
        <FormattedMessage
            id="sb.RemoveFromSavedSearchesToastContent.body"
            defaultMessage="{pageType, select,
                seller {Removed From Your Saved Sellers}
                other {Removed From Your Saved Searches}
            }"
            values={{ pageType: isSeller ? 'seller' : 'search' }}
        />
    </div>
);
